<template>
  <div v-if="isRouterAlive">
    <b-container ref="about50">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="12" md="2" lgt="2">
          <span class="about-title">精英团队</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class=" row about-content-info">
            <div class="col-10">
              通过不断的内部培养以及外部资源整合，“天鑫”目前拥有一支精英团队，其中既有为企业服务十余年，伴随企业共同成长的团队成员，也有外部引进的行业资深人士。“天鑫”以真诚开放的姿态不断注入新的血液，让这个团队时刻保持高效活力状态。
            </div>

            <div class="col-10">
              深知人才是企业发展的第一资源，“天鑫”一直不懈为团队打造一个真诚以待、有潜力的价值平台，以谋求个人和团队的共同发展。
            </div>
          </div>
          <b-img
            style="margin-top:40px;"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-1.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
          <div
            class="w-100"
            style=" border-bottom: 0.5px #bdbdbd66 solid;height:10px;width:100%;margin-top:50px;"
          ></div>
        </b-col>
      </b-row>
    </b-container>

    <b-container ref="about51">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="12" md="2" lgt="2">
          <span class="about-title">合作伙伴</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class=" row about-content-info">
            <div class="col-10">
              信任的深度，源自于服务的精度。“天鑫”多年来以真诚、务实、诚信的企业品质赢得了众多客户及合作伙伴的信赖，目前已服务全国500余家燃气企业，为多家大型燃气集团企业优选品牌，更在众多设备、原材料合作伙伴方赢得了诚实、守信的好口碑。
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="2" lgt="2">
          <b-img
            class="about-title-bootom"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-03.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
        </b-col>
        <b-col cols="12" md="10" lgt="10">
          <b-img
            style="margin-top:40px;"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-02.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
          <div
            class="w-100"
            style=" border-bottom: 0.5px #bdbdbd66 solid;height:10px;width:100%;margin-top:50px;"
          ></div>
        </b-col>
      </b-row>
    </b-container>

    <b-container ref="about52">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="12" md="2" lgt="2">
          <span class="about-title">客户服务</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class=" row about-content-info">
            <div class="col-10">
              客户满意，才是企业生存之道。“天鑫”专业的研发团队以及遍布全国二十多个销售服务网络，可以为客户提供专业化技术解决方案，系统化的培训，并承诺对客户需求48小时内快速反应的无忧服务。
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="2" lgt="2">
          <b-img
            class="about-title-bootom"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-05.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
        </b-col>
        <b-col cols="12" md="10" lgt="10">
          <b-img
            style="margin-top:40px;"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-04.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
          <div
            class="w-100"
            style=" border-bottom: 0.5px #bdbdbd66 solid;height:10px;width:100%;margin-top:50px;"
          ></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Sticky from "sticky-js";
export default {
  props: {
    active: {
      type: Number,
    },
  },
  data() {
    return {
      isRouterAlive: true,

      visible1: false,
    };
  },
  watch: {
    active(v) {
      console.log(v);
    },
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    getAbout5Page() {
      const _this = this;
      this.$store.dispatch("getAbout5Page").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky = new Sticky(".sticky");
        sticky.update();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
  },
  updated() {},
  mounted() {
    this.getAbout5Page();
  },
};
</script>
